module.exports = __webpack_public_path__ + "img/MoveOut.d1052245.svg";